import React from "react";
import ErrorState from "../ui/ErrorState/ErrorState";

const FeedErrorState = ({ onRetry }) => (
  <ErrorState
    title="Couldn't load your feed"
    description="Check your connection and try again."
    onRetry={onRetry}
  />
);

export default FeedErrorState;
